export default __webpack_public_path__ + "static/media/map-solar.5190100b.svg";